var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFundPerfomancePage2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.600098,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#B7D9B7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2177_119550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6001 17V19H23.6001V17H13.6001ZM18.6001 8C13.0801 8 8.6001 12.48 8.6001 18C8.6001 23.52 13.0801 28 18.6001 28C24.1201 28 28.6001 23.52 28.6001 18C28.6001 12.48 24.1201 8 18.6001 8ZM18.6001 26C14.1901 26 10.6001 22.41 10.6001 18C10.6001 13.59 14.1901 10 18.6001 10C23.0101 10 26.6001 13.59 26.6001 18C26.6001 22.41 23.0101 26 18.6001 26Z",
    fill: "#0C4A0D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2177_119550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6.6001 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundPerfomancePage2);
export default __webpack_public_path__ + "static/media/fundPerfomancePage2.cfa6df41b73b660025369722d5e0f70f.svg";
export { ForwardRef as ReactComponent };